export function resetColumnFilters(
  columnFilters: Record<string, string>
): Record<string, string> {
  const cleared: Record<string, string> = {};
  Object.keys(columnFilters).forEach(key => {
    cleared[key] = '';
  });
  return cleared;
}

export function getActiveFilterCount(
  filters: Record<string, string | null | boolean>
): number {
  let count = 0;
  Object.values(filters).forEach(value => {
    if (
      value === null ||
      value === undefined ||
      value === false ||
      value === ''
    ) {
      return;
    }
    if (typeof value === 'string' && !value.trim()) {
      return;
    }
    count++;
  });
  return count;
}

export function hasActiveFilters(
  filterValues: Record<string, string | null | boolean>,
  searchTerm: string
): boolean {
  return getActiveFilterCount(filterValues) > 0 || searchTerm.length > 0;
}
